import {defineMessages} from 'react-intl';

export default defineMessages({
	title: {
		id: 'plp.refinements.inTheMoodFor',
		defaultMessage:'In the mood for',
	},
});
